import axios from 'axios'

export const __API__ = 'https://guigotv-gateway-prd.guigo.tv/prepaid-partners/'

const defaultOptions = {
  baseURL: __API__,
}

const instance = axios.create(defaultOptions)

instance.interceptors.request.use(config => {
  return {
    ...config,
    headers: {
      ...config.headers,
    },
  }
})

instance.interceptors.response.use(
  function(response) {
    return response
  },
  error => {
    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      !['/', '/login', '/redefine-password', '/sign-up'].includes(window.location.pathname) &&
      !window.location.pathname.startsWith('/confirmation/') &&
      !window.location.pathname.startsWith('/define-password/')
    ) {
      window.location.href = '/login'
    } else {
      return Promise.reject(error)
    }
  },
)
export default instance
